import { useEffect, useRef, useState } from 'react'

// Whether the two-line clamp is actually hiding something. Width decides it - the panel is
// a 280px column at 960px and up but full-bleed below - so the paragraph is remeasured
// whenever it resizes rather than once on mount. While expanded there is nothing to
// measure (the clamp is off), so the last collapsed result stands and the control that got
// the reader there stays put.
function useIsClamped(text, isExpanded) {
  const ref = useRef(null)
  const [isClamped, setIsClamped] = useState(false)

  useEffect(() => {
    const node = ref.current
    if (!node || isExpanded) return undefined

    const measure = () => setIsClamped(node.scrollHeight > node.clientHeight)

    measure()

    if (typeof ResizeObserver === 'undefined') return undefined

    const observer = new ResizeObserver(measure)
    observer.observe(node)

    return () => observer.disconnect()
  }, [text, isExpanded])

  return [ref, isClamped]
}

export default useIsClamped
